"use strict";
exports.__esModule = true;
exports.usePriorities = void 0;
var priority_1 = require("../consts/priority");
function usePriorities(opts) {
    return {
        priorities: priority_1.Priorities,
        colors: priority_1.PriorityColorMap,
        icons: priority_1.PriorityIconsMap,
        labels: priority_1.PriorityLabels[opts.variant]
    };
}
exports.usePriorities = usePriorities;
;
